import React from 'react';
import { Link } from 'react-router-dom';

// TODO: replace with the real contact address
const CONTACT_EMAIL = '';

export default function SiteFooter() {
  return (
    <footer className="qs-footer">
      <span>© {new Date().getFullYear()} Qutron LLC</span>
      <div className="qs-footer__links">
        <Link to="/About">About</Link>
        <a href="https://lab.qutron.co">Lab</a>
        {CONTACT_EMAIL && <a href={`mailto:${CONTACT_EMAIL}`}>Contact</a>}
      </div>
    </footer>
  );
}
